module.exports = __webpack_public_path__ + "img/card_eden_disputeresolution.05f2c688.svg";